var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._b({staticClass:"subtitle-2 black--text"},'span',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.totalEntries)+" of "+_vm._s(_vm.total)+" Entries ")])}
var staticRenderFns = []

export { render, staticRenderFns }